import { VALIDATION_ERROR_MESSAGES } from "./constant-mixin";
import { isBlank } from "./component-utils-mixin";
import tinymce from "tinymce/tinymce";

// check for empty required field input
// @param: formElement e.g. this.$el (to prevent get other elements if use document.)
export const validateRequiredField = function (formElement) {
  let result = {
    result: true,
    message: "",
  }
  const requiredFields = formElement.querySelectorAll("[required]");
  Array.from(requiredFields).some(field => {
    if (isBlank(field.value)) {
      result.result = false;
      result.message = VALIDATION_ERROR_MESSAGES.FILL_REQUIRED_FIELD;
      return true; // break the some loop
    }
  })
  return result;
}

export const validateTinyMceEditor = function () {
  let result = {
    result: true,
    message: "",
  }
  const content = tinymce.get("tinyeditor").getContent();
  if (!content || content.trim() === "") {
    result.result = false;
    result.message = VALIDATION_ERROR_MESSAGES.FILL_EDITOR;
  }
  return result;
}

// check for fieldname special characters
// @param: formElement e.g. this.$el (to prevent get other elements if use document.)
export const validateFieldName = function (formElement) {
  let result = {
    result: true,
    message: "",
  }
  const fieldName = formElement.querySelector("input[name='fieldName']");
  const regex = new RegExp(/^[a-zA-Z]+\w*$/);
  if (!regex.test(fieldName.value)) {
    result.result = false;
    result.message = VALIDATION_ERROR_MESSAGES.NO_SPECIAL_CHAR;
  }
  return result
}

// check for options if the type is radio/checkboxes/dropdown
// @param: formElement e.g. this.$el (to prevent get other elements if use document.)
export const validateOptions = function (formElement) {
  let result = {
    result: true,
    message: "",
  }
  const options = formElement.querySelectorAll(".option-block");
  if (!options || options.length <= 0) {
    result.result = false;
    result.message = VALIDATION_ERROR_MESSAGES.ADD_OPTION;
    return result;
  }
  Array.from(options).some(option => {
    Array.from(option.querySelectorAll("input")).some(input => {
      if (isBlank(input.value)) {
        result.result = false;
        result.message = VALIDATION_ERROR_MESSAGES.FILL_OPTIONS;
        return true; // break the some loop
      }
    })
  })
  return result
}

export const validateExtensions = function (extension) {
  let res = {
    result: true,
    message: "" 
  }
  const regex = new RegExp(/^\.[a-z]+$|[a-z]+\/([a-z]|\*)+$/i);
  const trim = extension.trim();
  if (!regex.test(trim)) {
    res.result = false;
    res.message = `'${trim}' is an invalid extension`;
  }
  return res;
}